import addState from '../../utils/add-state';

export default function (app) {
	app.config(['$stateProvider', function ($stateProvider) {
		$stateProvider.state('forgotPassword', {
			url: '/forgot-password',
			template: ' '
		});
		addState($stateProvider, 'forgotPassword.emailForm', '^/emailForm');
		addState($stateProvider, 'forgotPassword.reminderSent', '^/reminderSent');
		addState($stateProvider, 'forgotPassword.errorSend', '^/errorSend');
		addState($stateProvider, 'forgotPassword.tokenExpired', '^/tokenExpired');
		addState($stateProvider, 'forgotPassword.successChange', '^/successChange');
		addState($stateProvider, 'forgotPassword.passwordForm', '^/passwordForm');
		addState($stateProvider, 'forgotPassword.passwordSMS', '^/sms');
	}]);
};
